import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import './Favourites.css';
import { Tooltip } from 'reactstrap';

class Favourites extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            tooltipOpen: false
        };

        this.toggle = this.toggle.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div>
                <button id="favorites" className="btn btn-link mr-2" onClick={this.toggle}><i style={{color: '#dcdcdc'}} className={'fa-2x fas fa-list'}></i>{this.props.buttonLabel}</button>
                <Tooltip placement="top" isOpen={this.state.tooltipOpen} target="favorites" toggle={this.toggleTooltip}>
                    List of favorite combinations
                </Tooltip>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Favorites</ModalHeader>
                    <ModalBody>

                        <div className="list-group">
                            {this.props.combinations.map((combination) => {
                                return (

                                    <li
                                        key={combination.id}
                                        className={classNames('list-group-item d-flex',
                                            'justify-content-between',
                                            'align-items-center',
                                            { active: this.props.playingCombinationTitle === combination.combinationTitle})}>
                                        <a
                                            onClick={() => this.props.handleClickPlayCombination(combination)}
                                            href="javascript:void(0)">{combination.combinationTitle}</a>
                                        <button
                                            onClick={() => this.props.handleClickDeleteCombination(combination.id)}
                                            type="button" className="btn btn-link"><i className="far fa-trash-alt"></i></button>
                                    </li>

                                )
                            })}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default Favourites;


// WEBPACK FOOTER //
// ./src/Favourites.js